import axios from '../axios';
import { toFormData, type FormPayload } from './formData';
import type {
  ApiEnvelope,
  Identifier,
  ListParams,
  PaginatedResponse,
  ProviderBidDto,
  ProviderBidPayload,
} from './types';

const API_URL = '/v1/provider/manpro/bids';

const serializeProviderBidPayload = (payload: ProviderBidPayload) => {
  const formPayload: FormPayload = {
    ...payload,
    documents: payload.documents,
    document_categories: payload.document_categories,
  };

  return toFormData(formPayload);
};

const providerBidService = {
  async getProviderBids(params?: ListParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderBidDto> | ProviderBidDto[]>>(
      API_URL,
      { params },
    );

    return response.data.content;
  },

  async getProviderBid(bidId: Identifier) {
    const response = await axios.get<ApiEnvelope<ProviderBidDto>>(`${API_URL}/${bidId}`);
    return response.data.content;
  },

  async createProviderBid(projectId: Identifier, payload: ProviderBidPayload) {
    const response = await axios.post<ApiEnvelope<ProviderBidDto>>(
      `/v1/provider/manpro/opportunities/${projectId}/bid`,
      serializeProviderBidPayload(payload),
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );

    return response.data.content;
  },

  async withdrawProviderBid(bidId: Identifier) {
    const response = await axios.post<ApiEnvelope<ProviderBidDto>>(
      `${API_URL}/${bidId}/withdraw`,
    );

    return response.data.content;
  },
};

export default providerBidService;
